




































import Vue from 'vue';
import DynamicFormFieldDefinitionResourceViewModel from '../../../services/v1/viewModel/resource/DynamicFormDefinitionResourceViewModel';
import GetDynamicFormDefinitionRequestViewModel from '../../../services/v1/viewModel/request/DynamicForm/GetDynamicFormDefinitionRequestViewModel';
import DynamicFormPostRequestViewModel from '../../../services/v1/viewModel/resource/DynamicFormPostRequestViewModel';
import DynamicFormPayloadResourceViewModel from '../../../services/v1/viewModel/resource/DynamicFormPayloadResourceViewModel';
import DynamicFormContactResourceViewModel from '../../../services/v1/viewModel/resource/DynamicFormContactResourceViewModel';

export default Vue.extend({
  name: 'DynamicForm',
  layout: 'layout-widget',
  props: {
    contactId: { default: undefined, type: String },
    definitionId: { default: undefined, type: String },
    appSystemKey: { default: undefined, type: String },
  },
  data: () => ({
    formSummary: {},
    isLoading: true,
    isPostingForm: false,
    errorResponse: undefined as any,
    formDefinition: new DynamicFormFieldDefinitionResourceViewModel(),
    formPayload: new DynamicFormPayloadResourceViewModel().fromModel({
      fields: [] as any,
      contact: new DynamicFormContactResourceViewModel(),
    }),
    wasFormPayloadSent: false,
  }),
  computed: {
    canPostForm(): boolean {
      return !this.isPostingForm && this.formDefinition.initalized;
    },
    innerAppSystemKey(): string {
      if (this._.isSet(this.appSystemKey)) {
        return this.appSystemKey;
      }
      if (this.$config.values['widget-dynamicform-appsystemkey']) {
        return this.$config.values['widget-dynamicform-appsystemkey'];
      }
      const queries = this.$routerUtils.getQueryParams();
      return queries.appsystemkey as string;
    },
    innerContactId(): string {
      if (this._.isSet(this.contactId)) {
        return this.contactId;
      }
      if (this.$config.values['widget-dynamicform-contactid']) {
        return this.$config.values['widget-dynamicform-contactid'];
      }
      const queries = this.$routerUtils.getQueryParams();
      return queries.contactid as string;
    },
    innerDefinitionId(): string {
      if (this._.isSet(this.definitionId)) {
        return this.definitionId;
      }
      if (this.$config.values['widget-dynamicform-formid']) {
        return this.$config.values['widget-dynamicform-formid'];
      }
      const queries = this.$routerUtils.getQueryParams();
      return queries.id as string;
    },
  },
  async mounted() {
    await this.loadFormDefinition();
  },
  methods: {
    windowBack() {
      let backFunc = this.$router.back.bind(this.$router);
      if (this._.isSet(window?.history)) {
        backFunc = window.history.back.bind(window.history);
      } else if (typeof (window as any)?.back === 'function') {
        backFunc = (window as any).back.bind(window);
      }
      backFunc();
    },
    async postForm() {
      this.isPostingForm = true;
      try {
        if (!this.formPayload.validate()) {
          this.isPostingForm = false;
          return;
        }
        this.formPayload.definitionId = this.formDefinition?.id!;
        this.formPayload.languageIso2 = this.$translation.get() ?? this.$config.values['language-default'];
        const req = new DynamicFormPostRequestViewModel().fromModel({
          appSystemKey: this.innerAppSystemKey,
          form: this.formPayload,
        });
        await this.$service.api.core.dynamicForm.postDynamicForm(req);
        this.wasFormPayloadSent = true;
      } catch (error: any) {
        this.errorResponse = error;
      }
      this.isPostingForm = false;
    },
    async loadFormDefinition() {
      this.isLoading = true;
      try {
        const req = new GetDynamicFormDefinitionRequestViewModel();
        req.appSystemKey = this.innerAppSystemKey;
        req.id = this.innerDefinitionId;
        this.errorResponse = undefined;
        this.formDefinition = await this.$service.api.core.dynamicForm.getDynamicFormDefinition(req);
      } catch (error: any) {
        this.errorResponse = error;
      }
      this.isLoading = false;
    },
  },
});
